module.exports = __webpack_public_path__ + "static/media/2.77c7a6a8.jpeg";